<template>
	<div class="alert alert-info widget-block">
		<label
			v-for="(el, k) in curList"
			:key="k"
			class="radio-inline">
			<input type="radio" :name="name" :value="el.id" v-model="curValue" @click="onSelect(el.id)"> {{ el.name | ftc }}
		</label>
		<button class="btn-close-filter close" @click.stop="$emit('closeFilter')">×</button>
	</div>
</template>

<script>
export default {
	name: 'filterRadio',
	props: ['list', 'name', 'value', 'crud'],
	data() {
		return {
			curValue: null,
			curList: false
		}
	},
	created() {
		this.update(this.value)
		this.makeList()
	},
	watch: {
		'value': function(newValue) {
			this.update(newValue)
		}
	},
	methods: {
		// выбрали значение
		onSelect(id) {
			// сообщим родителям что значение поменялось
			this.update(id)
			this.$emit('input', this.curValue)
		},
		// инициализация списка
		makeList() {
			this.curList = false
			// если задан список
			if (this.list && this.list['list'] && typeof this.list['list'] === 'object')
			{
				// если это объект
				if (!Array.isArray(this.list['list']))
				{
					// конвертируем в массив
					this.curList = []
					for (let key in this.list['list'])
					{
						let item = this.list['list'][key]
						if (typeof item === 'object' && item.id && item.name)
							this.curList.push(item)
						else
							this.curList.push({ id: key, name: item })
					}
				}
				else
				{
					// если это массив
					this.curList = this.list['list'].slice()
				}
			}
		},
		// обновление параметров компонента
		update(value) {
			this.curValue = value
		}
	}
}
</script>

<style scoped>
div.widget-block {
	font-size: 12px;
	padding: 15px;
}

div.widget-block input[type="radio"] {
    margin-top: 1px;
}

div.widget-block label {
	margin-right: 5px;
	user-select: none;
}

@media screen and (max-width: 767px) {
	div.widget-block {
		margin-bottom: 20px;
		width: 100%;
	}

	div.widget-block label {
		display: block;
		margin-left: 20px;
		padding: 10px 0;
	}
}

</style>



// WEBPACK FOOTER //
// filterRadio.vue?04712fbb